import React from "react";
import './pdfStyle.css'

export default class ComponentToPrint extends React.Component {
    render() {

        const reportData = (this.props.reportData).slice();;
        const selectedSearchValues = this.props.selectedSearchValues;
        const totalValues = this.props.totalValues;

        const formatMonth = (month) => {
            const [year, monthDigits] = month.split("-");
            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            const monthName = monthNames[parseInt(monthDigits, 10) - 1];

            return `${monthName} ${year}`;
        };

        const getIntakeDay = (row) => {
            const estateCropDay = row.estateCropDay;
            const tappersDay = row.tappersDay;
            const intakeDay = estateCropDay / tappersDay;
            return Number(intakeDay.toFixed(2));
        }


        const getIntakeTodate = (row) => {
            const estateCropTodate = row.estateCropToDate;
            const tappersTodate = row.tappersToDate;
            const intakeTodate = estateCropTodate / tappersTodate;
            return Number(intakeTodate.toFixed(2));
        }


        const getRevenueCombined = (row) => {
            const revenueLatex = row.revenueLatex;
            const revenueScrap = row.revenueScrap;
            const revenueCombined = revenueLatex + revenueScrap;
            return revenueCombined;
        }

        const getAbandonedTotal = (row) => {
            const abandonedLatex = row.abandonedLatex;
            const abandonedScrap = row.abandonedScrap;
            const abandonedTotal = abandonedLatex + abandonedScrap;
            return abandonedTotal;
        }

        const getRevenueAbandonedTotal = (row) => {
            const revenueCombined = getRevenueCombined(row);
            const abandonedTotal = getAbandonedTotal(row);
            const revenueAbandonedTotal = revenueCombined + abandonedTotal;
            return revenueAbandonedTotal;
        }

        return (
            <div style={{ width: '100%', marginTop: 0 }}>
                <div className="pdf-head">
                    <h6 style={{ color: "black !important" }}><u>{selectedSearchValues.group.toUpperCase()}</u></h6>
                    <h6 style={{ color: "black !important" }}><u>Daily Crop Summary</u></h6>
                    <h6 style={{ color: "black !important" }}>
                        ESTATE :  <span style={{ fontWeight: "bold" }}> {selectedSearchValues.estate.toUpperCase()}</span>
                    </h6>
                    <h6 style={{ color: "black !important" }}>
                        Month :  <span style={{ fontWeight: "bold" }}> {formatMonth(selectedSearchValues.month)}</span>
                    </h6>
                    <div className="pdf-root">
                        <table className="daily-crop-table" id="daily-crop-table">
                            <thead>
                                <tr className="no-border">
                                    <th align="center" colSpan="3" >
                                        Check roll weight
                                    </th>
                                    <th></th>
                                    <th align="center" colSpan="2">
                                        Factory Weight
                                    </th>
                                    <th colSpan="15" ></th>
                                </tr>
                                <tr >
                                    <th align="center" rowSpan="2" >
                                        DATE
                                    </th>
                                    <th align="center" colSpan="2" >
                                        ESTATE CROP - ACTUAL
                                    </th>
                                    <th align="center" colSpan="2" >
                                        Y.P.H
                                    </th>
                                    <th align="center" colSpan="2" >
                                        TAPPERS
                                    </th>
                                    <th align="center" colSpan="2" >
                                        INTAKE
                                    </th>
                                    <th align="center" colSpan="3" >
                                        Tappers Out Turn %
                                    </th>
                                    <th align="center" colSpan="2" >
                                        VACANT BLOCK
                                    </th>
                                    <th align="center" colSpan="3" >
                                        REVENUE CROP - KGS
                                    </th>
                                    <th align="center" colSpan="3" >
                                        Abandoned Crop
                                    </th>
                                    <th align="center" >
                                        TOTAL
                                    </th>
                                </tr>
                                <tr >
                                    <th align="center" >
                                        DAY
                                    </th>
                                    <th align="center" >
                                        TODATE
                                    </th>
                                    <th align="center" >
                                        DAY
                                    </th>
                                    <th align="center" >
                                        TODATE
                                    </th>
                                    <th align="center" >
                                        DAY
                                    </th>
                                    <th align="center" >
                                        TODATE
                                    </th>
                                    <th align="center" >
                                        DAY
                                    </th>
                                    <th align="center" >
                                        TODATE
                                    </th>
                                    <th align="center" >
                                        To be Taped
                                    </th>
                                    <th align="center" >
                                        Blocked taped
                                    </th>
                                    <th align="center" >
                                        Out Turn %
                                    </th>
                                    <th align="center" >
                                        DAY
                                    </th>
                                    <th align="center" >
                                        TODATE
                                    </th>
                                    <th align="center" >
                                        Latex
                                    </th>
                                    <th align="center" >
                                        Scrap
                                    </th>
                                    <th align="center" >
                                        Combined
                                    </th>
                                    <th align="center" >
                                        Latex
                                    </th>
                                    <th align="center" >
                                        Scrap
                                    </th>
                                    <th align="center" >
                                        Total
                                    </th>
                                    <th align="center" >
                                        Rev + aban
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {reportData.map(row => (
                                    <tr>
                                        <th align="center">
                                            {row.day}
                                        </th>
                                        <React.Fragment>
                                            <td align="right" >
                                                {isNaN(row.estateCropDay) || row.estateCropDay == 0 ? '-' : (row.estateCropDay).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN(row.estateCropToDate) || row.estateCropToDate == 0 ? '-' : (row.estateCropToDate).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {/*YPHDAY */}
                                            </td>
                                            <td align="right" >
                                                {/*YPHTODATE */}
                                            </td>
                                            <td align="right" >
                                                {isNaN(row.tappersDay) || row.tappersDay == 0 ? '-' : (row.tappersDay).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN(row.tappersToDate) || row.tappersToDate == 0 ? '-' : (row.tappersToDate).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN(getIntakeDay(row)) || getIntakeDay(row) == 0 ? '-' : (getIntakeDay(row)).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN(getIntakeTodate(row)) || getIntakeTodate(row) == 0 ? '' : (getIntakeTodate(row)).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {/*TAPPERSOUTTURN */}
                                            </td>
                                            <td align="right" >
                                                {/*TAPPERSOUTTURN */}
                                            </td>
                                            <td align="right" >
                                                {/*TAPPERSOUTTURN */}
                                            </td>
                                            <td align="right" >
                                                {/*VACANTBLOCK */}
                                            </td>
                                            <td align="right" >
                                                {/*VACANTBLOCK */}
                                            </td>
                                            <td align="right" >
                                                {isNaN(row.revenueLatex) || row.revenueLatex == 0 ? '-' : (row.revenueLatex).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN(row.revenueScrap) || row.revenueScrap == 0 ? '-' : (row.revenueScrap).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN((getRevenueCombined(row)).toFixed(2)) || (getRevenueCombined(row)).toFixed(2) == 0 ? '' : (getRevenueCombined(row)).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN(row.abandonedLatex) || row.abandonedLatex == 0 ? '-' : (row.abandonedLatex).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN(row.abandonedScrap) || row.abandonedScrap == 0 ? '-' : (row.abandonedScrap).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN((getAbandonedTotal(row)).toFixed(2)) || (getAbandonedTotal(row)).toFixed(2) == 0 ? '' : (getAbandonedTotal(row)).toFixed(2)}
                                            </td>
                                            <td align="right" >
                                                {isNaN(getRevenueAbandonedTotal(row)) || getRevenueAbandonedTotal(row) == 0 ? '' : getRevenueAbandonedTotal(row)}
                                            </td>
                                        </React.Fragment>
                                    </tr>
                                ))}
                            </tbody>
                            <tbody>
                                <tr>
                                    <th align="left">
                                        Total
                                    </th>
                                    <td align="right" >
                                        {totalValues.totalEstateCropDay == 0 ? '-' : (totalValues.totalEstateCropDay).toFixed(2)}
                                    </td>
                                    <td align="right" >
                                    </td>
                                    <td align="right" >
                                        {/*YPHDAY */}
                                    </td>
                                    <td align="right" >
                                        {/*YPHTODATE */}
                                    </td>
                                    <td align="right" >
                                    </td>
                                    <td align="right" >
                                        {/*TAPPERSTODATE */}
                                    </td>
                                    <td align="right" >
                                        {/*INTAKE DAY */}
                                    </td>
                                    <td align="right" >
                                        {/*INTAKE TODATE */}
                                    </td>
                                    <td align="right" >
                                        {/*TAPPERSOUTTURN */}
                                    </td>
                                    <td align="right" >
                                        {/*TAPPERSOUTTURN */}
                                    </td>
                                    <td align="right" >
                                        {/*TAPPERSOUTTURN */}
                                    </td>
                                    <td align="right" >
                                        {/*VACANTBLOCK */}
                                    </td>
                                    <td align="right" >
                                        {/*VACANTBLOCK */}
                                    </td>
                                    <td align="right" >
                                        {totalValues.totalRevenueLatex == 0 ? '-' : (totalValues.totalRevenueLatex).toFixed(2)}
                                    </td>
                                    <td align="right" >
                                        {totalValues.totalRevenueScrap == 0 ? '-' : (totalValues.totalRevenueScrap).toFixed(2)}
                                    </td>
                                    <td align="right" >
                                        {totalValues.totalRevenueCombined == 0 ? '-' : (totalValues.totalRevenueCombined).toFixed(2)}
                                    </td>
                                    <td align="right" >
                                        {totalValues.totalAbandonedLatex == 0 ? '-' : (totalValues.totalAbandonedLatex).toFixed(2)}
                                    </td>
                                    <td align="right" >
                                        {totalValues.totalAbandonedScrap == 0 ? '-' : (totalValues.totalAbandonedScrap).toFixed(2)}
                                    </td>
                                    <td align="right" >
                                        {totalValues.totalAbandonedTotal == 0 ? '-' : (totalValues.totalAbandonedTotal).toFixed(2)}
                                    </td>
                                    <td align="right" >
                                        {totalValues.totalRevenueAbandonedTotal == 0 ? '-' : (totalValues.totalRevenueAbandonedTotal).toFixed(2)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}